import {
  gql,
  MutationHookOptions,
  OperationVariables,
  useMutation,
} from '@apollo/client';

interface LogOperationResponse {
  logOperation: {
    body: {
      data: unknown;
      message: string;
      success: boolean;
    };
    status_code: number;
  };
}

export const LOG_OPERATION = gql`
  mutation logOperation($input: LogOperationInput!) {
    logOperation(input: $input) {
      body {
        data
        message
        success
      }
      status_code
    }
  }
`;

export const useLogOperation = (
  options?: MutationHookOptions<LogOperationResponse, OperationVariables>,
) => {
  return useMutation(LOG_OPERATION, options);
};
